<template>
    <div>
      <div class="popup-info popup-icon-info">
          <svg style="height: 48px;">
            <use xlink:href="@/assets/img/big-icons-sprite.svg#trash2"></use>
          </svg>

          <div class="text mt24">
              <div class="text-size-l text-bold info-title">Выйти без сохранения?</div>

              <p class="info-text mt16">
                  Все внесённые изменения будут утеряны.
              </p>
          </div>

          <div class="mt24">
              <submit-btn @click.native="close" :type="btnType"><span class="i i-ok7 mr4"></span>Подтвердить</submit-btn>
          </div>
      </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    import SubmitBtn from '@/components/forms/SubmitBtn.vue'

    export default {
        name: "ExitWithoutSave",
        components: {
            SubmitBtn
        },
        data() {
            return {
                btnType: 'normal',
            }
        },
        props: {
        },
        methods: {
            close: function () {
                this.$store.commit('popups/close', {name: this.popups.exitWithoutSave.name});
                this.$emit('apply');
            }
        },
        computed: {
            ...mapState({
                popups: state => state.popups.items,
                item: state => state.rules.openedRule,
                topSections: state => state.rules.topSections,
            }),
            activeTopSection(){
                if(this.isSearch) return false;
                return this.$route.params.id ? this.$route.params.id : this.topSections[0].id;
            },
        }
    }
</script>

<style scoped>

</style>
